import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_instance3bkco71y4m8oh as Companion_instance } from '../../../../../okio-parent-okio/okio/Options.mjs';
import { Companion_getInstance1jn7cnltecrtd as Companion_getInstance } from '../../../../../okio-parent-okio/okio/ByteString.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { bufferbiiev5vr4b6f as buffer } from '../../../../../okio-parent-okio/okio/Okio.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readHeaders($this, source) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var headers = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  $l$loop: while (true) {
    var line = source.readUtf8LineStrict_40ilic_k$();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(line) === 0)
      break $l$loop;
    var index = indexOf(line, _Char___init__impl__6a9atx(58));
    // Inline function 'kotlin.check' call
    if (!!(index === -1)) {
      var message = 'Unexpected header: ' + line;
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = substring(line, 0, index);
    var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.trim' call
    var this_1 = substring_0(line, index + 1 | 0);
    var tmp$ret$5 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (HttpHeader())(tmp, tmp$ret$5);
    headers.add_utx5q5_k$(element);
  }
  return headers;
}
var PartSourceClass;
function PartSource() {
  if (PartSourceClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
      }
      close_yn9xrc_k$() {
        if (equals(this.$this_1.currentPart_1, this)) {
          this.$this_1.currentPart_1 = null;
        }
      }
      read_iuuu3k_k$(sink, byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount < 0: ' + byteCount.toString();
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.check' call
        if (!equals(this.$this_1.currentPart_1, this)) {
          var message_0 = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
        }
        var limit = currentPartBytesRemaining(this.$this_1, byteCount);
        return limit === 0n ? -1n : this.$this_1.source_1.read_iuuu3k_k$(sink, limit);
      }
    }
    initMetadataForClass($, 'PartSource');
    PartSourceClass = $;
  }
  return PartSourceClass;
}
function currentPartBytesRemaining($this, maxResult) {
  $this.source_1.require_37jki9_k$(fromInt($this.crlfDashDashBoundary_1.get_size_woubt6_k$()));
  var delimiterIndex = $this.source_1.get_buffer_bmaafd_k$().indexOf_x7b6oe_k$($this.crlfDashDashBoundary_1);
  var tmp;
  if (delimiterIndex === -1n) {
    var tmp0 = $this.source_1.get_buffer_bmaafd_k$().size_1;
    // Inline function 'kotlin.Long.minus' call
    var other = $this.crlfDashDashBoundary_1.get_size_woubt6_k$();
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract(tmp0, fromInt(other));
    // Inline function 'kotlin.comparisons.minOf' call
    var b = add(this_0, fromInt(1));
    tmp = maxResult <= b ? maxResult : b;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    tmp = maxResult <= delimiterIndex ? maxResult : delimiterIndex;
  }
  return tmp;
}
var PartClass;
function Part() {
  if (PartClass === VOID) {
    class $ {
      constructor(headers, body) {
        this.headers_1 = headers;
        this.body_1 = body;
      }
      close_yn9xrc_k$() {
        this.body_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'Part');
    PartClass = $;
  }
  return PartClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var MultipartReaderClass;
function MultipartReader() {
  if (MultipartReaderClass === VOID) {
    class $ {
      constructor(source, boundary) {
        this.source_1 = source;
        this.boundary_1 = boundary;
        this.dashDashBoundary_1 = (new (Buffer())()).writeUtf8_9rv3au_k$('--').writeUtf8_9rv3au_k$(this.boundary_1).readByteString_nzt46n_k$();
        this.crlfDashDashBoundary_1 = (new (Buffer())()).writeUtf8_9rv3au_k$('\r\n--').writeUtf8_9rv3au_k$(this.boundary_1).readByteString_nzt46n_k$();
        this.partCount_1 = 0;
        this.closed_1 = false;
        this.noMoreParts_1 = false;
        this.currentPart_1 = null;
        this.afterBoundaryOptions_1 = Companion_instance.of_35g6b5_k$([Companion_getInstance().encodeUtf8_5n709n_k$('\r\n--' + this.boundary_1 + '--'), Companion_getInstance().encodeUtf8_5n709n_k$('\r\n'), Companion_getInstance().encodeUtf8_5n709n_k$('--'), Companion_getInstance().encodeUtf8_5n709n_k$(' '), Companion_getInstance().encodeUtf8_5n709n_k$('\t')]);
      }
      nextPart_njz4p2_k$() {
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'closed';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        if (this.noMoreParts_1)
          return null;
        if (this.partCount_1 === 0 && this.source_1.rangeEquals_gz1igj_k$(0n, this.dashDashBoundary_1)) {
          this.source_1.skip_csbv9x_k$(fromInt(this.dashDashBoundary_1.get_size_woubt6_k$()));
        } else {
          $l$loop: while (true) {
            var toSkip = currentPartBytesRemaining(this, 8192n);
            if (toSkip === 0n)
              break $l$loop;
            this.source_1.skip_csbv9x_k$(toSkip);
          }
          this.source_1.skip_csbv9x_k$(fromInt(this.crlfDashDashBoundary_1.get_size_woubt6_k$()));
        }
        var whitespace = false;
        afterBoundaryLoop: while (true) {
          switch (this.source_1.select_3l2gx4_k$(this.afterBoundaryOptions_1)) {
            case 0:
              if (this.partCount_1 === 0)
                throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('expected at least 1 part');
              this.noMoreParts_1 = true;
              return null;
            case 1:
              this.partCount_1 = this.partCount_1 + 1 | 0;
              break afterBoundaryLoop;
            case 2:
              if (whitespace)
                throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('unexpected characters after boundary');
              if (this.partCount_1 === 0)
                throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('expected at least 1 part');
              this.noMoreParts_1 = true;
              return null;
            case 3:
            case 4:
              whitespace = true;
              continue afterBoundaryLoop;
            case -1:
              if (this.source_1.exhausted_p1jt55_k$()) {
                throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('premature end of multipart body');
              } else {
                throw DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('unexpected characters after boundary');
              }

          }
        }
        var headers = readHeaders(Companion_instance_0, this.source_1);
        var partSource = new (PartSource())(this);
        this.currentPart_1 = partSource;
        return new (Part())(headers, buffer(partSource));
      }
      close_yn9xrc_k$() {
        if (this.closed_1)
          return Unit_instance;
        this.closed_1 = true;
        this.currentPart_1 = null;
        this.source_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'MultipartReader');
    MultipartReaderClass = $;
  }
  return MultipartReaderClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  MultipartReader as MultipartReader25md2ukkr9jti,
};
//endregion

//# sourceMappingURL=MultipartReader.mjs.map
